import { useDateNow } from 'hooks';
import { breakpoints } from 'styles';
import { PathStepTile } from '.';

import type { DetailedPath } from './PathViewDetailedInfo';

interface Props {
  path: DetailedPath;
}

const PathViewDetailedInfoSteps = ({ path }: Props) => {
  const { dateNow } = useDateNow();

  let stepEnabled = true;

  return (
    <div className="path-steps">
      {path.steps?.map((step, i) => {
        const deadline = path.deadlines?.[step.id];
        const progressData = path.progressData?.steps[step.id];
        const previousProgressData =
          path.progressData?.steps[path.steps[i - 1]?.id];

        if (stepEnabled && i > 0) {
          stepEnabled = !(
            path.requireCompletionBeforeNextCourse &&
            path.steps[i - 1].isMandatory &&
            !Boolean(previousProgressData?.completed)
          );
        }

        let denyAccess = false;
        if (deadline)
          denyAccess =
            step.deadlineDenyAccess && Date.parse(deadline) < dateNow;

        return (
          <div className="path-step" key={step.id}>
            <PathStepTile
              key={step.id}
              availableStepItemAchievementIds={
                path.availableStepItemAchievementIds
              }
              deadline={deadline}
              isCompleted={Boolean(progressData?.completed)}
              isMandatory={step.isMandatory}
              items={step.items}
              progress={progressData}
              stepAvailable={
                path.userIsEnrolled &&
                Date.parse(path.startDate) <= dateNow &&
                (!path.endDate || Date.parse(path.endDate) >= dateNow)
              }
              stepEnabled={stepEnabled && !denyAccess}
              stepNumber={step.number}
            />
          </div>
        );
      })}

      <style jsx>{`
        .path-steps {
          display: flex;
          flex-wrap: wrap;
          gap: 30px;
          width: 100%;
        }
        .path-step {
          width: 100%;
        }
        @media (min-width: ${breakpoints.small}px) {
          .path-step {
            width: calc(50% - 15px);
          }
        }
        @media (min-width: ${breakpoints.medium}px) {
          .path-step {
            width: calc(33.333% - 20px);
          }
        }
        @media (min-width: ${breakpoints.large}px) {
          .path-step {
            width: calc(25% - 22.5px);
          }
        }
      `}</style>
    </div>
  );
};

export default PathViewDetailedInfoSteps;
